<div *ngIf="reportType == 'briefly-personalledger'">
  <div class="container" id="print-section" style="margin: 0 auto; padding: 20px;">
    <table class="table table-bordered" style="width: 100%; border-collapse: collapse; font-size: 13px;">

      <!-- Table Header -->
      <thead>
        <tr>
          <th colspan="6" class="text-center" style="font-size: 16px; font-weight: bold; border: 2px solid black;">
            हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक
          </th>
          <th class="text-right" style="font-size: small; border: 2px solid black;">
            दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
          </th>
          <th class="text-center" style="border: 2px solid black;">पृष्ठ क्र</th>
        </tr>
        <tr>
          <th colspan="3" style="border: 2px solid black;">Issue Seller Personal Ledger</th>
          <th style="border: 2px solid black;">Date</th>
          <th style="border: 2px solid black;">From {{ startDate }}</th>
          <th style="border: 2px solid black;">To {{ endDate }}</th>
          <th colspan="2" style="border: 2px solid black;">In Briefly</th>
        </tr>
        <tr>
          <th style="border: 2px solid black;">Issue Seller Name</th>
          <th style="border: 2px solid black;">Deposit</th>
          <th style="border: 2px solid black;">Opening Balance</th>
          <th style="border: 2px solid black;">Billing Amount</th>
          <th style="border: 2px solid black;">Received Amount</th>
          <th style="border: 2px solid black;">Credit Note Amount</th>
          <th style="border: 2px solid black;">Total Amount</th>
          <th style="border: 2px solid black;">Balance</th>
          <!-- <th colspan="2" style="border: 2px solid black;">Receipt Date</th> -->
        </tr>
      </thead>

      <!-- Table Body -->
      <tbody>
        <tr *ngFor="let data1 of getpersonalledBridflydata">
          <td style="border: 1px solid black; text-align: left;">{{ data1.issue_seller_name }}</td>
          <td style="border: 1px solid black; text-align: right;">{{ data1.deposit || 0 }}</td>
          <td style="border: 1px solid black; text-align: right;"> {{ (data1.opening_bal || 0) | number: '1.2-2' }}
          </td>
           <td style="border: 1px solid black; text-align: right;">{{ data1.net_amt | number: '1.2-2' }}</td>
          <td style="border: 1px solid black; text-align: right;">{{ data1.rcv_amt | number: '1.2-2' }}</td>
          <td style="border: 1px solid black; text-align: right;">{{ data1.credit_amt | number: '1.2-2' }}</td>
          <td style="border: 1px solid black; text-align: right;">{{ data1.total_received_amt | number: '1.2-2' }}</td>
          <td style="border: 1px solid black; text-align: right;">{{ data1.bal_amt | number: '1.2-2' }}</td>
          <!-- <td colspan="2" style="border: 1px solid black;">{{ data1.rcpt_date }}</td> -->
        </tr>
      </tbody>

      <!-- Table Footer -->

      <tr>
        <td style="font-weight: bold; border: 2px solid black; background-color: #f0f8ff;">Total</td>
        <td style="text-align: right; font-weight: bold; border: 2px solid black; background-color: #f0f8ff;">{{
          totaldepo | number: '1.2-2' }}</td>
        <td style="text-align: right; font-weight: bold; border: 2px solid black; background-color: #f0f8ff;">{{ Totalop
          | number: '1.2-2' }}</td>
        <td style="text-align: right; font-weight: bold; border: 2px solid black; background-color: #f0f8ff;">{{
          Totalnet | number: '1.2-2' }}</td>
        <td style="text-align: right; font-weight: bold; border: 2px solid black; background-color: #f0f8ff;">{{
          Totalrcv | number: '1.2-2' }}</td>
        <td style="text-align: right; font-weight: bold; border: 2px solid black; background-color: #f0f8ff;">{{
          TotalCredit | number: '1.2-2' }}</td>
        <td style="text-align: right; font-weight: bold; border: 2px solid black; background-color: #f0f8ff;">{{
          TotalCreditTotal | number: '1.2-2' }}</td>
        <td style="text-align: right; font-weight: bold; border: 2px solid black; background-color: #f0f8ff;">{{
          Totalbal | number: '1.2-2' }}</td>
        <!-- <td colspan="2" style="border: 2px solid black;"></td> -->
      </tr>


    </table>
  </div>

  <!-- Buttons -->
  <div class="action-buttons noPrint" style="text-align: center; margin-top: 20px;">
    <button class="noPrint" (click)="exportExcel('Issue_seller_personal_ledger_Brifly_Report')" mat-raised-button
      color="primary">
      Export
    </button>

    <button class="noPrint" style="margin: 0 15px;" mat-raised-button color="primary" printSectionId="print-section"
      [useExistingCss]="true" ngxPrint>
      Print
    </button>

    <button class="noPrint" style="margin: 0 15px;" mat-button mat-dialog-close>
      Close
    </button>
  </div>
</div>